import { useDebouncedState } from '@sparklayer-io/spark-dash-ui/hooks/use-debounced-state';
import { useState } from 'react';
import { useCustomerLookupQuery } from '../hooks/use-customer-lookup-query';
import type { Customer } from '../types';
import { CustomerSearchTable } from './customer-search-table';

export function CustomerLookupSearch({
  initialSearchTerm = '',
  onSelect,
}: {
  initialSearchTerm?: string;
  onSelect: (customer: Customer, identifier: string) => void;
}) {
  const [searchTerm, setSearchTerm] = useState<string>(initialSearchTerm);
  const debouncedTerm = useDebouncedState(searchTerm, 400);
  const identifier = debouncedTerm.trim() ? debouncedTerm.trim() : undefined;

  const { data: found, isFetching } = useCustomerLookupQuery(identifier);

  return (
    <CustomerSearchTable
      searchTerm={searchTerm}
      debouncedTerm={debouncedTerm}
      customer={found?.customer}
      isFetching={isFetching}
      onSearchTermChange={setSearchTerm}
      onSelect={(customer) => {
        if (!identifier) return;
        onSelect(customer, identifier);
      }}
    />
  );
}
